// ═══════════════════════════════════════════════════════════════════════════
// PlayerBarPlaceholder — v1 state of the persistent player at the bottom
// of the app shell.
//
// Per STRATEGY_hosting_and_content.md (Path B), there's no native playback
// in v1 — clip hosting + YouTube embed lands in v1.5. This bar is shown
// instead of a fake player, communicating "something is coming here"
// without faking functionality.
//
// 64px tall, frosted, single line of muted copy + v1.5 marker.
//
// Hidden on routes where it visually conflicts with full-bleed feeds —
// AppShell decides via `hidePlayerBar` so this component stays dumb.
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';

export default function PlayerBarPlaceholder({ onLearnMore }) {
  return (
    <div role="region" aria-label="Native playback (coming soon)" style={styles.bar}>
      <div style={styles.left}>
        <span style={styles.icon} aria-hidden>🎧</span>
        <span style={styles.copy}>
          Native playback launches with clips &amp; episodes
        </span>
      </div>
      <button
        type="button"
        onClick={onLearnMore}
        style={styles.tag}
        aria-label="See the v1.5 roadmap"
      >
        v1.5 →
      </button>
    </div>
  );
}

const styles = {
  bar: {
    height: 64,
    width: '100%',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 20px',
    background: 'rgba(20, 24, 36, 0.8)',
    borderTop: '1px solid rgba(255, 255, 255, 0.06)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    color: 'var(--text, #f9f0e6)',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },

  left: {
    display: 'inline-flex', alignItems: 'center', gap: 12,
    minWidth: 0,
  },
  icon: {
    fontSize: 18,
    flexShrink: 0,
  },
  copy: {
    fontSize: 13.5,
    color: 'rgba(249, 240, 230, 0.55)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
  },

  tag: {
    flexShrink: 0,
    padding: '4px 10px',
    borderRadius: 999,
    background: 'rgba(255, 158, 64, 0.08)',
    border: '1px solid rgba(255, 158, 64, 0.18)',
    color: 'var(--gold, #ffb101)',
    fontSize: 11.5,
    fontWeight: 600,
    letterSpacing: '0.04em',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
};
